var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{ref:"data-table-bar-chart",staticClass:"data-table-bar-chart",style:({ 'font-size': _vm.barHeight - 2 }),attrs:{"viewBox":"0 0 300 50","preserveAspectRatio":"xMidYMid meet"}})}
var staticRenderFns = []

export { render, staticRenderFns }